import { SvgIcon, SvgIconProps } from '@mui/material'

export function LocalPin(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 24 24" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0ZM12 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M12 9.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 .75-.75Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5.376 15.584A.75.75 0 0 1 6 15.25h2a.75.75 0 0 1 0 1.5H6.401l-3 4.5H20.6l-3-4.5H16a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .624.334l4 6A.75.75 0 0 1 22 22.75H2a.75.75 0 0 1-.624-1.166l4-6Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default LocalPin
